<template>
  <div class="pos-layout">
    <Toast />

    <!-- Header Zone -->
    <div class="pos-header-zone">
      <POSHeader
        :user="user"
        :outlet="outlet"
        :is-open-shift="is_open_shift"
        :is-pending-shift="is_pending_shift"
        :opening-balance="opening_balance"
        :show-open-shift-dialog-prop="dialog.open_shift"
        :show-shift-warning-prop="dialog.shift_warning"
        :qty-total="qty_total"
        :cart-length="lengthCart"
        :hours="hours"
        :minutes="minutes"
        :seconds="seconds"
        @open-shift="confirmOpenShift"
        @confirm-open-shift="openShift"
        @audit-date-warning="openDialogAuditDate"
        @close-audit-warning="closeDialogAuditDate"
        @close-shift-warning="closeShiftWarning"
      />
    </div>

    <!-- Main Zone -->
    <div class="pos-main-zone">
      <div class="pos-main-content">
        <!-- POS Cart Component -->
        <div class="pos-cart-section">
          <POSCart
            :cart="cart"
            :is-open-shift="is_open_shift"
            :qty-total="qty_total"
            :cart-length="lengthCart"
            :sub-total="sub_total"
            :total-discount="total_discount"
            :voucher-amount="voucher_amount"
            :discount-transaction-value="discount_transaction_value"
            :total-billed-amount="total_billed_amount"
            @item-click="getCodeCatalog"
            @decrease-qty="minQty"
            @increase-qty="addQty"
            @update-item-discount="changeItemDiscount"
            @delete-item="deleteItem"
          />
        </div>

        <!-- POS Input Component -->
        <div class="pos-input-section">
          <POSInput
            ref="posInput"
            :barcode="search.barcode"
            @update:barcode="search.barcode = $event"
            :salespersons-filtered="salespersons_filtered"
            :salesperson-selected.sync="salespersons_selected"
            :customers="customers"
            :customer-selected="customers_selected"
            @update:customer-selected="customers_selected = $event"
            :is-error-customers="isError.customers"
            :discount-transaction-percentage.sync="
              discount_transaction_percentage
            "
            :discount-type.sync="discount_type"
            :discount-types="discount_types"
            :voucher-code.sync="voucher_code"
            :cancel-voucher="cancelVoucher"
            :is-open-shift="is_open_shift"
            :sub-total="sub_total"
            :total-billed-amount="total_billed_amount"
            :loading-transaction="loading.transaction"
            @search-barcode="searchBarcode"
            @search-salesperson="searchSalesperson"
            @search-customer="searchCustomer"
            @create-customer="createCustomer"
            @change-discount-transaction="changeDiscountTransaction"
            @validate-voucher="validateVoucher"
            @clear-voucher="clearVoucher"
            @save-transaction="saveTransaction"
          />
        </div>
      </div>
    </div>

    <!-- Controls Zone -->
    <div class="pos-controls-zone">
      <POSControls
        :is-open-shift="is_open_shift"
        :snapshot="snapshot"
        :loading-receipt="loading.lastReceipt"
        @open-catalog="openCatalogList"
        @open-gift="openDialogGiftClaim"
        @open-pending="openTransactionList"
        @open-refund="openDialogRefund"
        @open-receipt="openDialogStruk"
        @open-history="openHistoryList"
        @open-summary="openDialogRingkasan"
        @logout="openDialogLogout"
      />
    </div>

    <!-- POS Dialogs Component -->
    <POSDialogs
      :show-payment.sync="dialog.payment"
      :show-change.sync="dialog.change"
      :show-audit-date.sync="dialog.audit_date"
      :total-billed-amount="total_billed_amount"
      :payment-temp="payment_temp"
      :payment-methods="payment_methods"
      :payment-pay="payment_pay"
      :total-bayar="total_bayar"
      :infaq-payment-amount.sync="infaq_payment_amount"
      :round-up-return-amount.sync="round_up_return_amount"
      :money-changes="money_changes"
      :is-error-payment-amount="isError.payment_amount"
      :error-msg-payment-amount="error_msg.payment_amount"
      :is-error-infaq="isError.infaq"
      :error-msg-infaq="error_msg.infaq"
      :loading-payment="loading.payment"
      @check-payment-method="checkPaymentMethod"
      @calculate-change="calculateChange"
      @add-payment-method="addPaymentMethod"
      @remove-payment-method="removePaymentMethod"
      @calculate-infaq="calculateInfaq"
      @calculate-round-up="calculateRoundUp"
      @pay-transaction="payTransaction"
      @change-reset="changeReset"
      @close-audit-date="closeDialogAuditDate"
    />

    <!-- Receipt Preview Dialog -->
    <ReceiptPreviewDialog
      :visible.sync="dialog.receiptPreview"
      :invoice-id="receiptInvoiceId"
      :receipt-data-prop="lastReceiptData"
      @close="handleReceiptDialogClose"
    />

    <!-- Loading Overlay for Receipt Fetching -->
    <div v-if="loading.lastReceipt" class="receipt-loading-overlay">
      <div class="receipt-loading-content">
        <ProgressSpinner />
        <p class="p-mt-3">Memuat struk terakhir...</p>
      </div>
    </div>

    <!-- dialog catalog -->
    <Dialog
      :visible.sync="dialog.catalog"
      :style="{ width: '50%' }"
      header="Daftar Katalog"
      :modal="true"
      class="p-fluid"
    >
      <div style="width: 100%; overflow: auto">
        <DataView
          :value="items"
          :lazy="true"
          :paginator="true"
          :rows="item_limit"
          :totalRecords="item_total"
          :layout="layout"
          :loading="loading.filter"
          @page="getItems($event)"
        >
          <template #header>
            <div class="p-grid p-fluid">
              <div class="p-col-12 p-md-4 p-lg-4">
                <InputText
                  v-model="filter.name"
                  placeholder="Nama"
                  @keyup="debounceSearchName"
                />
              </div>
              <div class="p-col-12 p-md-4 p-lg-4">
                <InputText
                  v-model="filter.code"
                  placeholder="Barcode"
                  :maxlength="11"
                  @keyup="debounceSearchCode"
                  ref="barcode_catalog"
                />
              </div>
              <div class="p-col-12 p-md-4 p-lg-4">
                <InputText
                  v-model="filter.supplier"
                  placeholder="Supplier"
                  @keyup="debounceSearchSupplier"
                />
              </div>
            </div>
          </template>

          <template #empty>Data tidak tersedia.</template>
          <template #loading>Loading data item. Mohon tunggu.</template>

          <template #grid="slotProps">
            <div
              class="p-d-flex p-col-12 p-md-4 p-mt-2"
              style="cursor: pointer"
            >
              <div
                class="product-grid-item card"
                @click="loadCatalog(slotProps.data)"
              >
                <div class="product-grid-item-top">
                  <div>
                    <i class="pi pi-bookmark product-code-icon"></i>
                    <span class="product-code" style="margin: 0rem 0.2rem">{{
                      slotProps.data.code
                    }}</span>
                  </div>
                  <span
                    class="product-code-discount"
                    v-if="slotProps.data.discount != '0'"
                  >
                    {{ slotProps.data.discount }}%</span
                  >
                </div>
                <div class="product-grid-item-content">
                  <div>
                    <img
                      :src="
                        slotProps.data.thumbnail
                          ? slotProps.data.thumbnail
                          : no_image
                      "
                      :alt="slotProps.data.name"
                    />
                  </div>
                  <div class="product-name">{{ slotProps.data.name }}</div>
                  <div
                    class="product-initPrice"
                    v-if="slotProps.data.price != slotProps.data.init_price"
                  >
                    {{ slotProps.data.init_price | currency }}
                  </div>
                </div>
                <div class="product-price">
                  {{ slotProps.data.price | currency }}
                </div>
                <div class="product-description">
                  {{ slotProps.data.supplier }}
                </div>
                <div class="product-stok">
                  Stok : {{ slotProps.data.stock }}
                </div>
                <div
                  class="product-description"
                  v-if="slotProps.data.docDate == '0001-01-01T00:00:00Z'"
                >
                  -
                </div>
                <div class="product-description" v-else>
                  {{ slotProps.data.docDate.substr(0, 10) | formatDate }}
                </div>
              </div>
            </div>
          </template>
        </DataView>
      </div>
    </Dialog>
    <!-- end -->

    <Dialog
      :visible.sync="dialog.pending"
      :style="{ width: '70%' }"
      header="Transaksi Tertunda"
      :modal="true"
      class="p-fluid"
    >
      <div v-if="transactions.length == 0">
        <div class="p-col-12">
          <p>Data tidak ditemukan</p>
        </div>
      </div>
      <div class v-else>
        <div class="p-col-12">
          <table class="table table-responsive">
            <thead class="thead-light">
              <tr>
                <th>Cashier</th>
                <th>Customer</th>
                <th>Voucher Refund</th>
                <th>Tanggal</th>
                <th>Nominal</th>
                <th></th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="(an_item, k) in transactions" :key="k">
                <td>
                  {{ an_item.cashier.name }}
                </td>
                <td>
                  {{
                    an_item.customer.name
                      ? an_item.customer.name
                      : an_item.customer.phone
                  }}
                </td>
                <td>
                  {{
                    an_item.voucher.refund.code
                      ? an_item.voucher.refund.code
                      : '-'
                  }}
                </td>
                <td>
                  {{ an_item.created_at | basicDateTime }}
                </td>
                <td>{{ an_item.billed_amount | currency }}</td>
                <td>
                  <div>
                    <b-dropdown text="Lanjutkan" variant="primary" class="m-2">
                      <b-dropdown-item @click="loadTransaction(an_item)"
                        >Yes</b-dropdown-item
                      >
                      <b-dropdown-item
                        href="#"
                        @click="unfinished_transaction_dialog = false"
                        >No</b-dropdown-item
                      >
                    </b-dropdown>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </Dialog>

    <!-- dialog temporary omset -->
    <Dialog
      :visible.sync="dialogOmset"
      :style="{ width: '300px' }"
      header="Total Omset"
      :modal="true"
      :closable="false"
    >
      <div class="p-grid p-col-12 text-center">
        <b style="font-size: 18px">Omset : {{ temporaryOmset | currency }}</b>
      </div>

      <template #footer>
        <Button label="Ok" class="p-button-text" @click="dialogOmset = false" />
      </template>
    </Dialog>

    <Dialog
      :visible.sync="dialog.confirmGiftClaim"
      :style="{ width: '450px' }"
      header="Konfirmasi"
      :modal="true"
    >
      <div class="confirmation-content">
        <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem" />
        <span> Apakah kamu yakin ingin mengakhiri transaksi barang? </span>
      </div>
      <template #footer>
        <Button
          label="Tidak"
          icon="pi pi-times"
          class="p-button-text"
          @click="dialog.confirmGiftClaim = false"
        />
        <Button
          label="Ya"
          icon="pi pi-check"
          class="p-button-text"
          @click="openLinkTheSameTab('gift-claim', {})"
          v-shortkey.push="['enter']"
          @shortkey="openLinkTheSameTab('gift-claim', {})"
        />
      </template>
    </Dialog>

    <Dialog
      :visible.sync="dialog.confirmRefund"
      :style="{ width: '450px' }"
      header="Konfirmasi"
      :modal="true"
    >
      <div class="confirmation-content">
        <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem" />
        <span> Apakah kamu yakin ingin mengakhiri transaksi barang? </span>
      </div>
      <template #footer>
        <Button
          label="Tidak"
          icon="pi pi-times"
          class="p-button-text"
          @click="dialog.confirmRefund = false"
        />
        <Button
          label="Ya"
          icon="pi pi-check"
          class="p-button-text"
          @click="openLinkTheSameTab('refund', {})"
          v-shortkey.push="['enter']"
          @shortkey="openLinkTheSameTab('refund', {})"
        />
      </template>
    </Dialog>

    <Dialog
      :visible.sync="dialog.confirmStruk"
      :style="{ width: '450px' }"
      header="Konfirmasi"
      :modal="true"
    >
      <div class="confirmation-content">
        <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem" />
        <span> Apakah kamu yakin ingin mengakhiri transaksi barang? </span>
      </div>
      <template #footer>
        <Button
          label="Tidak"
          icon="pi pi-times"
          class="p-button-text"
          @click="dialog.confirmStruk = false"
        />
        <Button
          label="Ya"
          icon="pi pi-check"
          class="p-button-text"
          @click="showLastReceiptInDialog()"
          v-shortkey.push="['enter']"
          @shortkey="showLastReceiptInDialog()"
        />
      </template>
    </Dialog>

    <Dialog
      :visible.sync="dialog.emptyStruk"
      :style="{ width: '450px' }"
      header="Konfirmasi"
      :modal="true"
    >
      <div class="confirmation-content">
        <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem" />
        <span>Belum ada transaksi! </span>
      </div>
      <template #footer>
        <Button
          label="Ok"
          icon="pi pi-times"
          class="p-button-text"
          @click="dialog.emptyStruk = false"
          v-shortkey.push="['enter']"
          @shortkey="dialog.emptyStruk = false"
        />
      </template>
    </Dialog>

    <Dialog
      :visible.sync="dialog.history"
      :style="{ width: '50%' }"
      header="Riwayat"
      :modal="true"
      class="p-fluid"
    >
      <div class v-if="transaction_histories.length == 0">
        <div class="p-col-12">
          <p>Data tidak ditemukan</p>
        </div>
      </div>
      <div class v-else>
        <div class="p-col-12">
          <table class="table table-responsive">
            <thead class="thead-light">
              <tr>
                <th>Cashier</th>
                <th>Nomor Invoice</th>
                <th>Tanggal</th>
                <th>Total</th>
                <th></th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="(an_item, k) in transaction_histories" :key="k">
                <td>
                  {{ an_item.cashier }}
                </td>
                <td>
                  {{ an_item.number }}
                </td>
                <td>
                  {{ an_item.date | basicDateTime }}
                </td>
                <td>
                  {{ an_item.amount | currency }}
                </td>
                <td>
                  <div>
                    <Button
                      label="Print"
                      icon="pi pi-print"
                      @click="openReceiptPreview(an_item.id)"
                    />
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </Dialog>

    <Dialog
      :visible.sync="dialog.confirmRingkasan"
      :style="{ width: '450px' }"
      header="Konfirmasi"
      :modal="true"
    >
      <div class="confirmation-content">
        <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem" />
        <span> Apakah kamu yakin ingin mengakhiri transaksi barang? </span>
      </div>
      <template #footer>
        <Button
          label="Tidak"
          icon="pi pi-times"
          class="p-button-text"
          @click="dialog.confirmRingkasan = false"
        />
        <Button
          label="Ya"
          icon="pi pi-check"
          class="p-button-text"
          @click="openLinkTheSameTab('summary', {})"
          v-shortkey.push="['enter']"
          @shortkey="openLinkTheSameTab('summary', {})"
        />
      </template>
    </Dialog>

    <Dialog
      :visible.sync="dialog.confirmLogout"
      :style="{ width: '450px' }"
      header="Konfirmasi"
      :modal="true"
    >
      <div class="confirmation-content">
        <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem" />
        <span> Apakah kamu yakin ingin keluar? </span>
      </div>
      <template #footer>
        <Button
          label="Tidak"
          icon="pi pi-times"
          class="p-button-text"
          @click="dialog.confirmLogout = false"
        />
        <Button
          label="Ya"
          icon="pi pi-check"
          class="p-button-text"
          @click="logout"
          v-shortkey.push="['enter']"
          @shortkey="logout"
        />
      </template>
    </Dialog>
    <!-- create customer -->
    <Dialog
      :visible.sync="customer_dialog"
      :style="{ width: '450px' }"
      header="Tambah Pelanggan"
      :modal="true"
      class="p-fluid"
    >
      <div class="p-field p-mt-2">
        <label>Telepon</label>
        <InputText
          type="number"
          required
          ref="customer_phone"
          v-model="create_customer.phone"
          placeholder="Telepon"
          @keyup.prevent="isError.customer_phone = false"
        />
        <small class="p-error" v-if="isError.customer_phone">{{
          error_msg.customer_phone
        }}</small>
      </div>
      <template #footer>
        <Button
          label="Batal"
          class="p-button-outlined"
          @click="closeDialogCreateCustomer()"
        />
        <Button label="Tambah" class="p-button-info" @click="postCustomer()" />
      </template>
    </Dialog>
    <Dialog
      :visible.sync="customer_isExist_dialog"
      v-if="this.member_dialog_state"
      :style="{ width: '450px' }"
      header="Sudah Ada Member ?"
      :modal="true"
      class="p-fluid"
      @hide="setFocus()"
    >
      <div class="p-field p-mt-2 p-mb-10">
        <Button
          label="Ya, Sudah"
          class="p-button-info p-mt-2"
          @click="toggleCustomerExist"
        />
        <AutoComplete
          class="p-mt-2"
          :suggestions="customers"
          @complete="searchCustomer()"
          v-model="customers_selected"
          v-if="customerIsExist"
          placeholder="Pelanggan"
          :field="
            slotProps => (slotProps.name ? slotProps.name : slotProps.phone)
          "
          @keyup="searchCustomer()"
          :dropdown="true"
          :disabled="!is_open_shift"
          id="customer"
        >
          <template #item="slotProps">
            <div
              v-if="slotProps.index == 0"
              style="width: 50%; padding: 5px 0"
              class="add-customer"
            ></div>
            <div v-if="slotProps.item">
              <span v-if="slotProps.item.name"
                >{{ slotProps.item.name }} - </span
              >{{ slotProps.item.phone }}
            </div>
          </template>
        </AutoComplete>
        <Button
          v-if="!customerIsExist"
          label="Belum, Ingin Buat"
          class="p-button-outlined p-mt-2"
          @click="createCustomer()"
        />
      </div>
      <template #footer>
        <Button
          label="Batal"
          class="p-button-outlined"
          @click="closeCustomerExistDialog"
          v-shortkey.push="['escape']"
          @shortkey="closeCustomerExistDialog"
        />
        <Button
          label="Simpan"
          v-if="customerIsExist"
          class="p-button-outlined"
          @click="closeCustomerExistDialog"
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { debounce } from 'lodash'
import noImage from '../../assets/images/no-image.png'
import POSHeader from '@/components/pos/POSHeader.vue'
import POSControls from '@/components/pos/POSControls.vue'
import POSCart from '@/components/pos/POSCart.vue'
import POSInput from '@/components/pos/POSInput.vue'
import POSDialogs from '@/components/pos/POSDialogs.vue'
import ReceiptPreviewDialog from '@/components/pos/ReceiptPreviewDialog.vue'
import receiptService from '@/services/receiptService'
import ProgressSpinner from 'primevue/progressspinner'
import {
  AUDIT_DATE_THRESHOLD_HOURS,
  MAX_DISCOUNT_PERCENTAGE,
  KEYBOARD_SHORTCUTS,
  SEARCH_DEBOUNCE_MS,
  TIME_UPDATE_INTERVAL_MS,
  DEFAULT_ITEM_LIMIT,
  DISCOUNT_TYPES,
  SHIFT_STATUS,
  TOAST_DURATION_MS,
  FOCUS_DELAY_MS
} from '@/constants/pos'

export default {
  components: {
    ReceiptPreviewDialog,
    POSHeader,
    POSControls,
    POSCart,
    POSInput,
    POSDialogs,
    ProgressSpinner
  },
  props: ['voucher_code_used'],
  computed: {
    globalInvoiceId() {
      return this.payment.invoice_id
    },
    hasAnyDialogOpen() {
      // Check all dialog states
      return (
        this.customer_isExist_dialog ||
        this.dialog.payment ||
        this.dialog.change ||
        this.dialog.receiptPreview ||
        this.dialog.audit_date ||
        this.dialog.shift_warning ||
        this.dialog.history ||
        this.dialog.pending ||
        this.dialog.catalog ||
        this.dialog.emptyStruk ||
        this.dialog.confirmGiftClaim ||
        this.dialog.confirmRefund ||
        this.dialog.confirmStruk ||
        this.dialog.confirmRingkasan ||
        this.dialog.confirmLogout ||
        this.dialog.open_shift
      )
    },
    ...mapState(['user', 'isAuthenticated'])
  },
  created() {
    // Store bound methods for cleanup
    this.eventListeners.keydown = this.shortcutListener
    this.eventListeners.keyup = e => {
      console.info(e.key)
    }

    // Use capture phase to ensure our handler runs BEFORE vue-shortkey
    // Listen on both window and document to catch events before vue-shortkey
    window.addEventListener('keydown', this.eventListeners.keydown, true)
    document.addEventListener('keydown', this.eventListeners.keydown, true)
    window.addEventListener('keyup', this.eventListeners.keyup)

    this.debounceSearchName = debounce(this.searchName, SEARCH_DEBOUNCE_MS)
    this.debounceSearchCode = debounce(this.searchCode, SEARCH_DEBOUNCE_MS)
    this.debounceSearchSupplier = debounce(
      this.searchSupplier,
      SEARCH_DEBOUNCE_MS
    )
  },
  watch: {
    user() {
      this.getAuthUser()
      // Timer is now managed by setupTimeInterval() in mounted
      this.checkAuditDateWarning()
    },
    // Watch dialog.payment to calculate remaining amounts when dialog opens
    'dialog.payment'(newVal) {
      if (newVal) {
        // When payment dialog opens, calculate remaining amounts for each payment method
        this.$nextTick(() => {
          if (this.payment_temp && this.payment_temp.length > 0) {
            this.payment_temp.forEach((payment, index) => {
              // If payment method is non-cash (is_cash = 0), set amount to remaining balance
              if (
                payment.payment_method_id &&
                !this.isPaymentMethodCash(payment.payment_method_id)
              ) {
                const remainingAmount = this.getRemainingAmount(index)
                this.$set(payment, 'amount', remainingAmount)
              }
            })
            // Trigger calculation to update totals
            this.calculateChange()
          }
        })
      }
    },
    // Watch payment_temp amounts for real-time calculation
    payment_temp: {
      handler(newVal, oldVal) {
        // Only recalculate if dialog is open and amounts actually changed
        if (this.dialog.payment && newVal && oldVal) {
          // Check if any amount changed
          const amountsChanged = newVal.some((payment, index) => {
            const oldPayment = oldVal[index]
            return oldPayment && payment.amount !== oldPayment.amount
          })

          if (amountsChanged) {
            // Find the index that changed
            const changedIndex = newVal.findIndex((payment, index) => {
              const oldPayment = oldVal[index]
              return oldPayment && payment.amount !== oldPayment.amount
            })

            if (changedIndex >= 0) {
              this.$nextTick(() => {
                this.calculateChange(changedIndex)
              })
            }
          }
        }
      },
      deep: true
    }
  },
  data() {
    return {
      today: new Date().toISOString().split('T')[0],
      name: '',
      outlet: {},
      outlet_id: 0,
      hours: '00',
      minutes: '00',
      seconds: '00',
      snapshot: [],
      no_image: noImage,

      salespersons: [],
      salespersons_filtered: null,
      salespersons_selected: null,

      customers: [],
      customers_selected: null,
      customer_dialog: false,
      customer_isExist_dialog: false,
      customerIsExist: false,
      types: [{ type: 'REGULAR' }, { type: 'RESELLER' }],
      selected_type: null,

      create_customer: {
        name: '',
        email: '',
        phone: '',
        type: 'REGULAR'
      },

      items: [],
      item_limit: DEFAULT_ITEM_LIMIT,
      item_total: 0,

      isError: {
        infaq: false,
        round_up: false,
        payment_method: false,
        discount_item: false,
        customers: false,
        customer_phone: false
      },

      error_msg: {
        infaq: '',
        payment_amount: '',
        discount_item: '',
        customer_phone: ''
      },

      search: {
        name: '',
        barcode: '',
        code: ''
      },

      cart: [],
      lengthCart: 0,
      iterasi: 0,

      qty_total: 0,
      sub_total: 0,
      total_discount: 0,
      billed_amount: 0,
      total_billed_amount: 0,

      discount_type: null,
      discount_types: [DISCOUNT_TYPES.PERCENTAGE, DISCOUNT_TYPES.AMOUNT],
      discount_transaction_percentage: null,
      discount_transaction_value: 0,

      transactions: [],
      transaction: {
        id: '',
        salesperson_id: null,
        cust_id: null,
        items: [],
        discount: null,
        voucher_code: ''
      },
      transaction_histories: [],

      voucher_code: '',
      voucher_amount: 0,
      cancelVoucher: false,

      total_bayar: 0,
      payment_temp: [
        {
          payment_method_id: null,
          amount: 0
        }
      ],
      payment: {
        invoice_id: 0,
        infaq: 0,
        payment: [],
        round_up: '',
        voucher_code: '',
        change: 0
      },

      dialog: {
        open_shift: false,
        shift_warning: false,
        pending: false,
        history: false,
        payment: false,
        change: false,
        catalog: false,
        confirmGiftClaim: false,
        confirmRefund: false,
        confirmStruk: false,
        emptyStruk: false,
        confirmRingkasan: false,
        confirmLogout: false,
        audit_date: false,
        receiptPreview: false
      },
      receiptInvoiceId: null,
      lastReceiptData: null, // Receipt data for preview dialog
      member_dialog_state: false,
      payment_amount: 0,
      infaq_payment_amount: 0,
      round_up_return_amount: 0,
      money_changes: 0,

      opening_balance: 0,
      is_pending_shift: false,
      is_open_shift: false,
      opened_at: null,

      payment_methods: [],
      payment_method_selected: null,
      bank_account: null,
      store: {
        name: process.env.STORE_NAME,
        addr: process.env.STORE_ADDR,
        phone: process.env.STORE_PHONE
      },

      layout: 'grid',
      loading: {
        filter: false,
        payment: false,
        transaction: false,
        lastReceipt: false
      },

      filter: {
        name: '',
        code: '',
        supplier: '',
        show_empty_stock: true
      },
      payment_pay: false,
      temporaryOmset: null,
      dialogOmset: false,
      enterPressed: false,
      timeInterval: null,
      eventListeners: {
        keydown: null,
        keyup: null
      }
    }
  },
  mounted() {
    this.getAuthUser()
    this.loadVoucher()
    this.getSalespersons()
    this.getItems()
    this.getPaymentMethods()
    this.setupTimeInterval()
    setTimeout(this.setFocus, FOCUS_DELAY_MS)
    this.checkAuditDateWarning()
  },
  beforeDestroy() {
    // Remove event listeners
    if (this.eventListeners.keydown) {
      // Remove with capture flag to match how we added it
      window.removeEventListener('keydown', this.eventListeners.keydown, true)
      document.removeEventListener('keydown', this.eventListeners.keydown, true)
    }
    if (this.eventListeners.keyup) {
      window.removeEventListener('keyup', this.eventListeners.keyup)
    }

    // Clear intervals
    this.clearTimeInterval()
  },

  methods: {
    getAuthUser() {
      if (this.user) {
        this.name = this.user.name
        this.outlet_id = this.user.outlet_id

        // Always get outlet data regardless of shift status
        this.getOutlets()

        if (this.user.shift) {
          this.opened_at = this.user.shift.opened_at
          this.is_pending_shift =
            this.user.shift.status === SHIFT_STATUS.PENDING
          this.is_open_shift = this.user.shift.status === SHIFT_STATUS.OPEN
          this.dialog.shift_warning = !(
            this.is_pending_shift || this.is_open_shift
          )
          this.member_dialog_state = this.user.show_member_dialog
          this.getTemporaryOmset()
          if (this.is_open_shift == true) {
            this.showCustDialogExist()
          }
        } else {
          // No shift - set default states
          this.is_pending_shift = false
          this.is_open_shift = false
          this.dialog.shift_warning = true
        }
      }
    },

    showCustDialogExist() {
      if (this.user.shift.status === 'OPEN') {
        this.customer_isExist_dialog = true
      }
    },

    toggleCustomerExist() {
      this.customerIsExist = !this.customerIsExist
    },

    closeCustomerExistDialog() {
      this.customer_isExist_dialog = false
      this.member_dialog_state = false // Ensure both states are cleared
      this.setFocus()
    },

    openDialogAuditDate() {
      this.dialog.audit_date = true
    },

    closeDialogAuditDate() {
      this.dialog.audit_date = false
      sessionStorage.setItem('auditWarningDismissed', '1')
    },

    closeShiftWarning() {
      this.dialog.shift_warning = false
    },

    setFocus() {
      if (this.$refs.posInput && this.$refs.posInput.$refs.barcode) {
        this.$refs.posInput.$refs.barcode.$el.focus()
      }
    },

    shortcutListener(e) {
      if (e.keyCode === KEYBOARD_SHORTCUTS.F4) {
        // f4 = focus to discount item (first discount input in cart)
        e.preventDefault()
        if (this.cart.length > 0) {
          // Find first discount input using class selector
          const discountItem = document.querySelector('.discount-input')
          if (discountItem) {
            discountItem.focus()
            discountItem.select() // Select text for easy editing
          }
        }
      }
      if (e.keyCode === KEYBOARD_SHORTCUTS.F5) {
        // f5 = refresh  or load page
        e.preventDefault()
        window.location.reload()
      }
      if (e.keyCode === KEYBOARD_SHORTCUTS.F8) {
        // f8 = focus to field pramuniaga
        e.preventDefault()
        const salespersonField = document.getElementById('pramuniaga')
        if (salespersonField) {
          salespersonField.focus()
        }
      }
      if (e.keyCode === KEYBOARD_SHORTCUTS.F10) {
        //f10 = focus to field jumlah diskon
        e.preventDefault()
        const discountAmountField = document.getElementById('jumlah-diskon')
        if (discountAmountField) {
          discountAmountField.focus()
        }
      }
      // Note: SPACE key is handled by component-level v-shortkey directive
      // on the "Bayar" button in POSInput.vue to ensure single execution
      // and respect button disabled states
      // Note: ENTER key is handled by component-level v-shortkey directives
      // to avoid conflicts with dialog confirm actions (pay, print, etc.)
      if (e.keyCode === KEYBOARD_SHORTCUTS.DELETE) {
        // Delete key = Close member dialog
        if (this.customer_isExist_dialog && this.member_dialog_state) {
          e.preventDefault()
          this.closeCustomerExistDialog()
        }
      }
      if (e.keyCode === KEYBOARD_SHORTCUTS.ESC) {
        // ESC = Close dialogs in priority order, or logout if no dialogs open
        // Use capture phase and stop immediate propagation to prevent vue-shortkey from firing
        let dialogWasClosed = false

        // Priority 1: Close member dialog if visible
        if (this.customer_isExist_dialog && this.member_dialog_state) {
          e.preventDefault()
          e.stopImmediatePropagation()
          this.closeCustomerExistDialog()
          dialogWasClosed = true
          return
        }

        // Priority 2: Close payment dialog if visible
        if (this.dialog.payment) {
          e.preventDefault()
          e.stopImmediatePropagation()
          this.dialog.payment = false
          dialogWasClosed = true
          return
        }

        // Priority 3: Close change dialog if visible
        if (this.dialog.change) {
          e.preventDefault()
          e.stopImmediatePropagation()
          this.dialog.change = false
          dialogWasClosed = true
          return
        }

        // Priority 4: Close receipt preview dialog if visible
        if (this.dialog.receiptPreview) {
          e.preventDefault()
          e.stopImmediatePropagation()
          this.handleReceiptDialogClose()
          dialogWasClosed = true
          return
        }

        // Priority 5: Close audit date dialog if visible
        if (this.dialog.audit_date) {
          e.preventDefault()
          e.stopImmediatePropagation()
          this.closeDialogAuditDate()
          dialogWasClosed = true
          return
        }

        // Priority 6: Close other dialogs
        if (this.dialog.shift_warning) {
          e.preventDefault()
          e.stopImmediatePropagation()
          this.dialog.shift_warning = false
          dialogWasClosed = true
          return
        }
        if (this.dialog.history) {
          e.preventDefault()
          e.stopImmediatePropagation()
          this.openHistoryList(false)
          dialogWasClosed = true
          return
        }
        if (this.dialog.pending) {
          e.preventDefault()
          e.stopImmediatePropagation()
          this.openTransactionList(false)
          dialogWasClosed = true
          return
        }
        if (this.dialog.catalog) {
          e.preventDefault()
          e.stopImmediatePropagation()
          this.openCatalogList(false)
          dialogWasClosed = true
          return
        }
        if (this.dialog.emptyStruk) {
          e.preventDefault()
          e.stopImmediatePropagation()
          this.dialog.emptyStruk = false
          dialogWasClosed = true
          return
        }
        if (this.dialog.confirmGiftClaim) {
          e.preventDefault()
          e.stopImmediatePropagation()
          this.dialog.confirmGiftClaim = false
          dialogWasClosed = true
          return
        }
        if (this.dialog.confirmRefund) {
          e.preventDefault()
          e.stopImmediatePropagation()
          this.dialog.confirmRefund = false
          dialogWasClosed = true
          return
        }
        if (this.dialog.confirmStruk) {
          e.preventDefault()
          e.stopImmediatePropagation()
          this.dialog.confirmStruk = false
          dialogWasClosed = true
          return
        }
        if (this.dialog.confirmRingkasan) {
          e.preventDefault()
          e.stopImmediatePropagation()
          this.dialog.confirmRingkasan = false
          dialogWasClosed = true
          return
        }
        if (this.dialog.confirmLogout) {
          e.preventDefault()
          e.stopImmediatePropagation()
          this.dialog.confirmLogout = false
          dialogWasClosed = true
          return
        }
        if (this.dialog.open_shift) {
          e.preventDefault()
          e.stopImmediatePropagation()
          this.dialog.open_shift = false
          dialogWasClosed = true
          return
        }

        // Priority 7: If no dialogs are open, open logout confirmation dialog
        // Prevent default and stop propagation to prevent vue-shortkey from firing
        if (!this.hasAnyDialogOpen && !dialogWasClosed) {
          e.preventDefault()
          e.stopImmediatePropagation()
          this.openDialogLogout(true)
        }
      }
    },

    getTemporaryOmset() {
      let audit_date
      if (this.opened_at) {
        audit_date = this.user.shift.audit_date
      }

      this.$http
        .get(`${process.env.VUE_APP_API_URL}/pos/omset/${audit_date}`)
        .then(response => {
          if (response.status === 200) {
            this.temporaryOmset = response.data.data.total_omset.total
          }
        })
    },

    showTemporaryOmset() {
      this.dialogOmset = true
    },

    closeTemporaryOmset() {
      this.dialogOmset = false
    },

    loadVoucher() {
      if (this.voucher_code_used) {
        this.voucher_code = this.voucher_code_used
        this.validateVoucher()
      } else {
        this.voucher_code = ''
      }
    },

    validateVoucher() {
      this.$http
        .post(`${process.env.VUE_APP_API_URL}/pos/vouchers/validation`, {
          voucher_code: this.voucher_code
        })
        .then(response => {
          if (response.data.code == 200) {
            this.voucher_amount = parseFloat(response.data.data.amount)
            this.cancelVoucher = true
            this.$toast.add({
              severity: 'success',
              summary: 'Voucher berhasil digunakan',
              life: TOAST_DURATION_MS
            })
            this.calculateTotal(true)
          } else {
            this.$toast.add({
              severity: 'error',
              summary: 'Voucher gagal digunakan',
              detail: 'Tolong, cek kembali kode voucher',
              life: TOAST_DURATION_MS
            })
            return false
          }
        })
    },

    clearVoucher() {
      this.cancelVoucher = false
      this.voucher_code = ''
      this.voucher_amount = 0

      this.calculateTotal(true)
      this.calculateDiscount()
    },

    getOutlets() {
      if (!this.outlet_id) {
        console.warn('No outlet_id available')
        return
      }

      this.$http
        .get(`${process.env.VUE_APP_API_URL}/outlets/${this.outlet_id}`)
        .then(response => {
          if (response.status === 200 && response.data.success) {
            this.outlet = response.data.data.outlets
            if (this.outlet && this.outlet.phone) {
              this.getCustomers('', this.outlet.phone)
            }
          }
        })
        .catch(error => {
          console.error('Error fetching outlet:', error)
          // Keep outlet as empty object to prevent prop type errors
          this.outlet = {}
        })
    },

    getSnapshot(event) {
      this.$http
        .get(
          `${process.env.VUE_APP_API_URL}/outlet-items/snapshot?barcode=${event}`
        )
        .then(response => {
          if (response.status === 200) {
            this.snapshot = response.data.data.snapshot
            this.search.barcode = ''
            this.getItems()
          }
        })
    },

    getCodeCatalog(event) {
      this.getSnapshot(event)
    },

    setTime() {
      const date = new Date()
      let hours = date.getHours()
      let minutes = date.getMinutes()
      let seconds = date.getSeconds()
      this.hours = hours.toString().padStart(2, '0')
      this.minutes = minutes.toString().padStart(2, '0')
      this.seconds = seconds.toString().padStart(2, '0')
    },

    setupTimeInterval() {
      // Clear existing interval if any
      if (this.timeInterval) {
        clearInterval(this.timeInterval)
      }

      // Set initial time
      this.setTime()

      // Create new interval
      this.timeInterval = setInterval(() => {
        this.setTime()
      }, TIME_UPDATE_INTERVAL_MS)
    },

    clearTimeInterval() {
      if (this.timeInterval) {
        clearInterval(this.timeInterval)
        this.timeInterval = null
      }
    },

    getSalespersons() {
      this.$http
        .get(`${process.env.VUE_APP_API_URL}/employees?role=SALESPERSON`)
        .then(response => {
          if (response.status === 200) {
            this.salespersons = response.data.data.employees
          }
        })
    },

    searchSalesperson(event) {
      this.salespersons_filtered = this.salespersons.filter(item => {
        return item.name.toLowerCase().startsWith(event.query.toLowerCase())
      })
    },

    getCustomers(name = '', no_telp = '', create = false) {
      if (no_telp != '') name = ''
      // check if no_telp has 0 in first word then change into 62
      if (no_telp != '' && no_telp[0] == '0') {
        no_telp = no_telp.replace('0', '62')
      }
      this.$http
        .get(
          `${process.env.VUE_APP_API_URL}/customers?name=${name}&no_telp=${no_telp}&page=&limit=`
        )
        .then(response => {
          if (response.status == 200) {
            this.customers = response.data.data.customers
            // loop and check if phone number starts with '62', change it to '0'
            for (let i = 0; i < this.customers.length; i++) {
              if (
                this.customers[i].phone.startsWith('62') &&
                this.customers[i].phone != this.outlet.phone
              ) {
                this.customers[i].phone = '0' + this.customers[i].phone.slice(2)
              }
            }
            if (this.customers.length == 0) {
              this.isError.customers = true
            } else {
              this.isError.customers = false
              this.customersDefault(create)
            }
          }
        })
    },

    customersDefault(create) {
      if (this.customers_selected == null)
        this.customers_selected = this.customers.filter(
          item => item.phone == this.outlet.phone
        )[0]
      if (this.customers_selected == '') this.customers_selected = null
      if (create) this.customers_selected = this.customers[0]
    },

    searchCustomer() {
      let no_telp, name
      // check if this.selectedCustomer contains number assign into no_telp
      if (/^\d+$/.test(this.customers_selected)) {
        no_telp = this.customers_selected
      } else if (this.customers_selected instanceof Object) {
        name = this.customers_selected.name
      } else {
        name = this.customers_selected
      }
      this.getCustomers(name, no_telp)
    },

    createCustomer() {
      this.customer_isExist_dialog = false
      this.customer_dialog = true
      this.create_customer.phone = ''
      this.isError.customer_phone = false
      setTimeout(() => {
        this.customers_selected = null
        if (this.$refs.customer_phone) {
          this.$refs.customer_phone.$el.focus()
        }
      }, 500)
    },

    closeDialogCreateCustomer() {
      this.customer_dialog = false
      this.create_customer.phone = ''
      this.isError.customer_phone = false
      this.customersDefault('', this.outlet.phone)
      this.setFocus()
    },

    postCustomer() {
      if (this.create_customer.phone == '') {
        this.isError.customer_phone = true
        this.error_msg.customer_phone = 'Mohon isi telepon'
      }

      this.create_customer.type = 'REGULAR'
      this.create_customer.email = this.create_customer.phone

      this.loading.create = true
      if (!this.isError.customer_phone) {
        this.$http
          .post(
            `${process.env.VUE_APP_API_URL}/customers`,
            this.create_customer
          )
          .then(response => {
            if (response.status === 200) {
              this.customer_dialog = false
              this.getCustomers('', this.create_customer.phone, true)
              this.create_customer.phone = ''
              this.$toast.add({
                severity: 'success',
                summary: 'Berhasil menambahkan pelanggan',
                life: TOAST_DURATION_MS
              })
            } else {
              if (response.data.message == 'error.customer.duplicate') {
                this.$toast.add({
                  severity: 'error',
                  summary: 'Pelanggan sudah terdaftar',
                  life: TOAST_DURATION_MS
                })
              } else {
                this.$toast.add({
                  severity: 'error',
                  summary: 'Gagal menambahkan pelanggan',
                  life: TOAST_DURATION_MS
                })
              }
            }
          })
      }
    },

    getItems(event) {
      let page = 1
      if (event) {
        page = event.page + 1
      }

      this.loading.filter = true
      this.$http
        .get(
          `${process.env.VUE_APP_API_URL}/outlet-items?page=${page}&limit=${this.item_limit}&name=${this.filter.name}&code=${this.filter.code}&barcode=${this.search.barcode}&supplier=${this.filter.supplier}`
        )
        .then(response => {
          this.loading.filter = false
          this.filter.name = ''
          this.filter.code = ''
          this.filter.supplier = ''
          if (response.status === 200) {
            this.items = response.data.data.items
            this.item_total = response.data.data.total
          }
        })
        .catch(error => {
          console.error('getItems error:', error)
          this.loading.filter = false
        })
    },

    calculateTotalBayar() {
      let total_bayar = 0

      for (const payment of this.payment_temp) {
        const amount = payment.amount || 0
        total_bayar += isNaN(amount) ? 0 : amount
      }

      // Total bayar should be the sum of all payment amounts
      this.total_bayar = total_bayar
    },

    getRemainingAmount(excludeIndex = -1) {
      // Calculate remaining balance needed to pay the bill
      // excludeIndex: index of payment method to exclude from calculation
      let totalPaid = 0
      this.payment_temp.forEach((payment, index) => {
        if (index !== excludeIndex && payment && payment.amount) {
          const amount = parseFloat(payment.amount) || 0
          totalPaid += isNaN(amount) ? 0 : amount
        }
      })
      const remaining = this.total_billed_amount - totalPaid
      return Math.max(0, remaining) // Never return negative
    },

    searchName() {
      this.loading.filter = true
      if (this.filter.name == '') {
        this.getItems()
      } else {
        this.$http
          .get(
            `${process.env.VUE_APP_API_URL}/outlet-items?name=${this.filter.name}`
          )
          .then(response => {
            this.loading.filter = false
            if (response.status === 200) {
              this.items = response.data.data.items
              this.item_total = response.data.data.total
            }
          })
      }
    },

    searchCode() {
      this.loading.filter = true
      if (this.filter.code == '') {
        this.getItems()
      } else {
        this.$http
          .get(
            `${process.env.VUE_APP_API_URL}/outlet-items?code=${this.filter.code}`
          )
          .then(response => {
            this.loading.filter = false
            if (response.status === 200) {
              this.items = response.data.data.items
              this.item_total = response.data.data.total
            }
          })
      }
    },

    searchSupplier() {
      this.loading.filter = true
      if (this.filter.supplier == '') {
        this.getItems()
      } else {
        this.$http
          .get(
            `${process.env.VUE_APP_API_URL}/outlet-items?supplier=${this.filter.supplier}`
          )
          .then(response => {
            this.loading.filter = false
            if (response.status === 200) {
              this.items = response.data.data.items
              this.item_total = response.data.data.total
            }
          })
      }
    },

    searchBarcode() {
      //check the barcode if contain qty
      let arr = this.search.barcode.split('*')
      let bcode = this.search.barcode
      let qty = 1
      if (arr.length > 1) {
        bcode = arr[1]
        qty = arr[0]
      }
      this.$http
        .get(`${process.env.VUE_APP_API_URL}/outlet-items?barcode=${bcode}`)
        .then(response => {
          if (response.status === 200) {
            this.items = response.data.data.items
            this.item_total = response.data.data.total

            if (this.items.length === 1) {
              let count = this.cart.filter(
                item => item.code === this.items[0].code
              ).length
              let datas = 0
              if (count >= 0) {
                for (const item of this.cart) {
                  if (item.code === this.items[0].code) {
                    datas += item.qty
                  }
                }
              }

              if (
                count == this.items[0].stock ||
                datas >= this.items[0].stock
              ) {
                this.$toast.add({
                  severity: 'error',
                  summary: 'Qty melebihi stok',
                  life: TOAST_DURATION_MS
                })
              } else {
                this.getSnapshot(bcode)
                this.addToCart(this.items[0], qty)
                this.discount_type = 'Persen'
                this.search.barcode = ''
              }
            } else {
              this.$toast.add({
                severity: 'error',
                summary: 'Invalid Barcode',
                detail: 'This item not found',
                life: TOAST_DURATION_MS
              })
            }
          }
        })
    },

    getPaymentMethods() {
      this.$http
        .get(`${process.env.VUE_APP_API_URL}/payment-methods`)
        .then(response => {
          if (response.status === 200) {
            this.payment_methods = response.data.data.payment_methods.filter(
              item => item.name !== 'GIFT' && item.name !== 'VOUCHER'
            )
            this.payment_temp[0].payment_method_id =
              this.payment_methods.filter(item => item.name === 'CASH')[0]
          }
        })
    },

    isPaymentMethodCash(paymentMethod) {
      // Check if payment method is cash (is_cash = 1)
      if (!paymentMethod) return false
      // Support both is_cash field and name check for backward compatibility
      if (paymentMethod.is_cash !== undefined) {
        return paymentMethod.is_cash === 1
      }
      // Fallback to name check if is_cash is not available
      return paymentMethod.name === 'CASH'
    },
    checkPaymentMethod(index, item) {
      if (this.payment_temp.length > 1) {
        this.payment_pay = false
        for (let i = 0; i < index; i++) {
          if (this.payment_temp[i].payment_method_id.name == item.name) {
            this.$toast.add({
              severity: 'error',
              summary: 'Payment method sudah ada',
              detail: 'Tidak boleh sama',
              life: TOAST_DURATION_MS
            })
            this.payment_temp[index].payment_method_id = ''
            return
          }
        }
        // For multiple payment methods, set non-cash to remaining amount
        const isCash = this.isPaymentMethodCash(item)
        if (!isCash) {
          this.$nextTick(() => {
            if (this.payment_temp[index]) {
              const remainingAmount = this.getRemainingAmount(index)
              this.$set(this.payment_temp[index], 'amount', remainingAmount)
              this.calculateChange(index)
            }
          })
        }
      } else {
        // Use is_cash field instead of name check
        const isCash = this.isPaymentMethodCash(item)
        if (isCash) {
          this.payment_pay = false
        } else {
          this.payment_pay = true
          // Set amount to remaining balance (which equals total_billed_amount for first payment)
          this.$nextTick(() => {
            if (this.payment_temp[index]) {
              const remainingAmount = this.getRemainingAmount(index)
              this.$set(this.payment_temp[index], 'amount', remainingAmount)
              this.calculateChange(index)
            }
          })
        }
      }
    },

    openCatalogList(value) {
      // Default to true if no value is passed
      const shouldOpen = value !== undefined ? value : true
      this.dialog.catalog = shouldOpen
      setTimeout(() => {
        if (this.$refs.barcode_catalog && this.$refs.barcode_catalog.$el) {
          this.$refs.barcode_catalog.$el.focus()
        }
      }, 1000)
      this.getItems()
    },

    changeReset() {
      this.dialog.change = false
      this.money_changes = 0
      setTimeout(() => {
        if (this.$refs.posInput && this.$refs.posInput.$refs.barcode) {
          this.$refs.posInput.$refs.barcode.$el.focus()
        }
        this.customer_isExist_dialog = true
        // this.customers_selected = null
      }, 1000)
    },

    loadCatalog(data) {
      //check the barcode if contain qty
      let arr = this.search.barcode.split('*')
      let brcode = data.code
      let qty = 1
      if (arr.length > 1) {
        brcode = arr[1]
        qty = arr[0]
      }
      this.$http
        .get(`${process.env.VUE_APP_API_URL}/outlet-items?barcode=${brcode}`)
        .then(response => {
          if (response.status === 200) {
            this.items = response.data.data.items
            this.item_total = response.data.data.total
            this.getSnapshot(brcode)

            if (this.items.length === 1) {
              let count = this.cart.filter(
                item => item.code === this.items[0].code
              ).length
              let datas = 0
              if (count >= 0) {
                for (const cartItem of this.cart) {
                  if (cartItem.code === this.items[0].code) {
                    datas += cartItem.qty
                  }
                }
              }
              if (
                count == this.items[0].stock ||
                datas >= this.items[0].stock
              ) {
                this.$toast.add({
                  severity: 'error',
                  summary: 'Qty melebihi stok',
                  life: TOAST_DURATION_MS
                })
              } else {
                this.addToCart(this.items[0], qty)
                this.discount_type = 'Persen'
                this.dialog.catalog = false
              }
            } else {
              this.$toast.add({
                severity: 'error',
                summary: 'Stok barang sudah kosong',
                life: TOAST_DURATION_MS
              })
            }
          }
        })
    },

    openTransactionList(value) {
      this.dialog.pending = value !== undefined ? value : true
      this.getTransactions()
    },

    getTransactions() {
      this.$http
        .get(`${process.env.VUE_APP_API_URL}/pos/transactions`)
        .then(response => {
          if (response.status === 200) {
            this.transactions = response.data.data.transactions
          }
        })
    },

    loadTransaction(data) {
      this.dialog.pending = false
      this.cart = []
      this.transaction.id = data.id
      this.customers_selected = data.customer
      this.salespersons_selected = data.sales_person
      this.voucher_code = data.voucher.refund.code

      if (data.discount > 0) {
        this.discount_type = 'Rupiah'
        this.discount_transaction_percentage = parseInt(data.discount)
        this.discount_transaction_value = data.discount
      } else {
        this.discount_type = null
        this.discount_transaction_percentage = null
        this.discount_transaction_value = 0
      }

      data.items.forEach((items, index) => {
        this.cart.unshift({ ...items, iterasi: index + 1 })
      })

      this.checkcart()
      this.calculateDiscount()
      this.calculateTotal(true)

      if (this.voucher_code != '') {
        this.validateVoucher()
      } else {
        console.warn('No voucher founded')
      }
    },

    openDialogGiftClaim(value) {
      if (this.cart.length === 0) {
        this.openLinkTheSameTab('gift-claim', {})
      } else {
        this.dialog.confirmGiftClaim = value !== undefined ? value : true
      }
    },

    openDialogRefund(value) {
      if (this.cart.length === 0) {
        this.openLinkTheSameTab('refund', {})
      } else {
        this.dialog.confirmRefund = value !== undefined ? value : true
      }
    },

    openDialogStruk() {
      // Always show last receipt in dialog when Struk button is clicked
      this.showLastReceiptInDialog()
    },

    async showLastReceiptInDialog() {
      // Fetch last receipt and show in dialog
      // Set loading state
      this.loading.lastReceipt = true

      try {
        // Debug logging
        if (process.env.NODE_ENV === 'development') {
          console.log('Fetching last receipt...')
        }

        const receiptData = await receiptService.fetchLastReceipt(this.$http)

        // Debug logging
        if (process.env.NODE_ENV === 'development') {
          console.log('Receipt data received:', receiptData)
        }

        // Check if receipt data exists and has invoice
        if (!receiptData) {
          this.loading.lastReceipt = false
          this.$toast.add({
            severity: 'warn',
            summary: 'Tidak ada struk terakhir',
            detail: 'Data struk tidak ditemukan',
            life: TOAST_DURATION_MS
          })
          return
        }

        if (!receiptData.invoice) {
          this.loading.lastReceipt = false
          console.error('Receipt data missing invoice:', receiptData)
          this.$toast.add({
            severity: 'error',
            summary: 'Data struk tidak lengkap',
            detail: 'Invoice data tidak ditemukan',
            life: TOAST_DURATION_MS
          })
          return
        }

        // Get invoice ID - use invoice.id from endpoint response
        const invoiceId = receiptData.invoice.id

        if (!invoiceId) {
          this.loading.lastReceipt = false
          console.error('Receipt data missing invoice ID:', receiptData.invoice)
          this.$toast.add({
            severity: 'error',
            summary: 'Data struk tidak lengkap',
            detail: 'Invoice ID tidak ditemukan',
            life: TOAST_DURATION_MS
          })
          return
        }

        // Store receipt data directly to avoid second API call
        // Use Vue.set to ensure reactivity
        this.$set(this, 'lastReceiptData', receiptData)
        this.$set(this, 'receiptInvoiceId', invoiceId)

        // Debug logging
        if (process.env.NODE_ENV === 'development') {
          console.log('Stored receipt data:', {
            receiptInvoiceId: this.receiptInvoiceId,
            hasReceiptData: !!this.lastReceiptData,
            invoiceId: invoiceId,
            invoice: receiptData.invoice
          })
        }

        // Open dialog - use $nextTick to ensure props are set first
        this.$nextTick(() => {
          // Ensure dialog state is set
          this.$set(this.dialog, 'receiptPreview', true)

          // Clear loading state after dialog opens
          this.loading.lastReceipt = false

          // Debug logging
          if (process.env.NODE_ENV === 'development') {
            console.log('Dialog opened:', {
              dialogReceiptPreview: this.dialog.receiptPreview,
              receiptInvoiceId: this.receiptInvoiceId,
              lastReceiptData: this.lastReceiptData,
              dialogState: this.dialog
            })
          }
        })
      } catch (error) {
        this.loading.lastReceipt = false
        console.error('Error fetching last receipt:', error)
        this.$toast.add({
          severity: 'error',
          summary: 'Gagal memuat struk terakhir',
          detail: error.message || 'Terjadi kesalahan saat memuat struk',
          life: TOAST_DURATION_MS
        })
      }
    },

    handleReceiptDialogClose() {
      this.dialog.receiptPreview = false
      this.receiptInvoiceId = null
      this.lastReceiptData = null
    },

    openReceiptPreview(invoiceId) {
      this.receiptInvoiceId = invoiceId
      this.dialog.receiptPreview = true
    },

    openDialogRingkasan(value) {
      if (this.cart.length === 0) {
        this.openLinkTheSameTab('summary', {})
      } else {
        this.dialog.confirmRingkasan = value !== undefined ? value : true
      }
    },

    openDialogLogout(value) {
      this.dialog.confirmLogout = value !== undefined ? value : true
    },

    checkcart() {
      const duplikatObj = [...new Map(this.cart.map(item => [item.id, item]))]
      this.lengthCart = duplikatObj.length
    },

    addToCart(value, initQty = 1) {
      this.iterasi = this.cart.length

      if (value && value.isGift) {
        this.$toast.add({
          severity: 'error',
          summary: 'Barang hadiah tidak bisa ditransaksikan',
          detail: 'Gunakan menu Klaim Hadiah',
          life: TOAST_DURATION_MS
        })
        return
      }

      if (this.is_open_shift === true) {
        this.cart.unshift({
          iterasi: this.iterasi + 1,
          id: value.id,
          code: value.code,
          name: value.name,
          stock: value.stock,
          qty: parseInt(initQty),
          price: parseFloat(value.price),
          discount: parseFloat(value.discount)
        })
        this.checkcart()
        this.calculateDiscount()
        this.calculateTotal(false)
        this.changeDiscountTransaction()
      } else {
        this.$toast.add({
          severity: 'error',
          summary: 'Mulai shift terlebih dahulu',
          life: TOAST_DURATION_MS
        })
      }
    },

    checkDiscountVoucher() {
      if (this.cart.length === 0) {
        this.voucher_code = ''
        this.voucher_amount = 0
        this.cancelVoucher = false
      }
    },

    addQty(data) {
      let count = this.cart.filter(item => item.code === data.code).length
      let datas = 0
      if (count >= 0) {
        for (const item of this.cart) {
          if (item.code === data.code) {
            datas += item.qty
          }
        }
      }

      if (
        data.stock <= data.qty ||
        count == data.stock ||
        datas >= data.stock
      ) {
        this.$toast.add({
          severity: 'error',
          summary: 'Qty melebihi stok',
          life: TOAST_DURATION_MS
        })
      } else {
        data.qty += 1
      }

      this.discount_type = null
      this.discount_transaction_value = 0
      this.discount_transaction_percentage = null

      this.calculateDiscount()
      this.checkcart()
      this.calculateTotal(true)
    },

    minQty(data) {
      if (data.qty >= 1) {
        data.qty -= 1
      }

      if (data.qty <= 0) {
        let idx = this.cart.indexOf(data)
        if (idx > -1) {
          this.cart.splice(idx, 1)
          this.snapshot = []
        }
      }

      this.discount_type = null
      this.discount_transaction_value = 0
      this.discount_transaction_percentage = null

      this.checkDiscountVoucher()
      this.checkcart()
      this.calculateDiscount()
      this.calculateTotal(true)
    },

    deleteItem(data) {
      let idx = this.cart.indexOf(data)
      if (idx > -1) {
        this.cart.splice(idx, 1)
        this.snapshot = []
        this.search.barcode = ''
      }

      this.discount_type = null
      this.discount_transaction_value = 0
      this.discount_transaction_percentage = null

      this.checkDiscountVoucher()
      this.checkcart()
      this.calculateDiscount()
      this.calculateTotal(false)
      this.changeDiscountTransaction()
    },

    changeItemDiscount() {
      this.calculateDiscount()
      this.calculateTotal(true)
    },

    changeDiscountTransaction() {
      // Use reactive data - discount_transaction_percentage is already bound via v-model
      const parsedPrice =
        typeof this.discount_transaction_percentage === 'number'
          ? this.discount_transaction_percentage
          : parseInt(
              String(this.discount_transaction_percentage || 0).replace(
                /\./g,
                ''
              )
            )

      this.discount_transaction_percentage = parsedPrice || null

      if (
        this.discount_transaction_percentage >= 100 &&
        this.discount_type === 'Persen'
      ) {
        this.discount_transaction_percentage = 100
      }

      this.discount_transaction_value = 0
      if (this.discount_type === 'Persen') {
        if (this.discount_transaction_percentage <= 100) {
          this.discount_transaction_value =
            this.discount_transaction_percentage * (this.billed_amount / 100)
        } else {
          this.discount_transaction_percentage =
            (this.discount_transaction_percentage / this.billed_amount) * 100
          this.discount_transaction_value =
            this.discount_transaction_percentage * (this.billed_amount / 100)
        }
      } else if (this.discount_type === 'Rupiah') {
        this.discount_transaction_value = this.discount_transaction_percentage
      }

      this.calculateDiscount()
      this.calculateTotal(false)
    },

    changePaymentTransaction() {
      if (this.payment_method_selected.name != 'CASH') {
        this.payment_temp.amount[0] = this.total_billed_amount
        this.infaq_payment_amount = 0
        this.round_up_return_amount = 0
      }
    },

    calculateTotal(tampil) {
      this.billed_amount = 0
      this.total_billed_amount = 0
      this.sub_total = 0
      this.qty_total = 0
      let iterasi = this.cart.length
      for (const cartItem of this.cart) {
        cartItem.iterasi = iterasi--
        this.billed_amount += cartItem.qty * cartItem.price
        this.sub_total += cartItem.qty * cartItem.price
        this.qty_total += cartItem.qty
      }

      this.billed_amount = this.sub_total - this.total_discount
      this.total_billed_amount =
        this.billed_amount -
        parseInt(this.discount_transaction_value) -
        this.voucher_amount

      if (this.total_billed_amount < 0 && tampil) {
        this.$toast.add({
          severity: 'error',
          summary: 'Belanja anda kurang dari voucher',
          life: TOAST_DURATION_MS
        })
      } else if (this.total_billed_amount < 0 && !tampil) {
        this.$toast.add({
          severity: 'error',
          summary: 'Belanja anda melebihi discount',
          life: TOAST_DURATION_MS
        })
      }
    },

    calculateChange(index = 0) {
      // Use reactive data - payment_temp[index].amount is already bound via v-model
      const payment = this.payment_temp[index]
      if (!payment) return

      // Ensure amount is a number (InputNumber component should handle this, but ensure type safety)
      let parsedPrice = 0

      if (typeof payment.amount === 'number') {
        // If it's already a number, check if it's valid
        parsedPrice = isNaN(payment.amount) ? 0 : payment.amount
      } else if (
        payment.amount === null ||
        payment.amount === undefined ||
        payment.amount === ''
      ) {
        // Handle null, undefined, or empty string
        parsedPrice = 0
      } else {
        // Parse string value, removing thousand separators
        const cleaned = String(payment.amount).replace(/\./g, '')
        parsedPrice = parseInt(cleaned, 10)
        // Check if parsing resulted in NaN
        if (isNaN(parsedPrice)) {
          parsedPrice = 0
        }
      }

      payment.amount = parsedPrice

      // Check if payment method is non-cash (is_cash = 0)
      if (
        payment.payment_method_id &&
        this.isPaymentMethodCash(payment.payment_method_id) === false
      ) {
        // Calculate remaining amount needed
        const remainingAmount = this.getRemainingAmount(index)
        // Only auto-set if amount is 0 or exceeds remaining amount
        // This preserves user input when they manually enter a valid amount
        if (payment.amount === 0 || payment.amount > remainingAmount) {
          payment.amount = remainingAmount
        }
      }

      let total_bayar = 0

      for (const paymentItem of this.payment_temp) {
        const amount = paymentItem.amount || 0
        total_bayar += isNaN(amount) ? 0 : amount
      }

      this.calculateTotalBayar()

      // Check if all payment methods are non-cash (is_cash = 0)
      const hasCashPayment = this.payment_temp.some(
        item =>
          item.payment_method_id &&
          this.isPaymentMethodCash(item.payment_method_id)
      )

      if (total_bayar < this.total_billed_amount) {
        this.isError.payment_amount = true
        this.error_msg.payment_amount = 'Jumlah pembayaran tidak cukup'
        this.loading.payment = false
        // Set money_changes to 0 when payment is insufficient
        this.money_changes = 0
      } else {
        this.isError.payment_amount = false

        // If no cash payment method, kembalian is always 0
        if (!hasCashPayment) {
          this.money_changes = 0
          return
        }

        // Calculate base kembalian (change amount)
        let kembalian = total_bayar - this.total_billed_amount

        // Apply infaq if set (subtract from kembalian)
        // Parse infaq amount properly - handle string values and remove formatting
        // Infaq should be an integer (rupiah), so use parseInt, not parseFloat
        let infaqAmount = 0
        if (
          this.infaq_payment_amount != null &&
          this.infaq_payment_amount !== '' &&
          this.infaq_payment_amount !== 0
        ) {
          // Handle string values (remove any formatting like dots for thousands, commas)
          if (typeof this.infaq_payment_amount === 'string') {
            // Remove all non-digit characters, then parse as integer
            const cleaned = String(this.infaq_payment_amount).replace(
              /[^\d]/g,
              ''
            )
            infaqAmount = parseInt(cleaned, 10) || 0
            // Debug log to see what's happening
            if (process.env.NODE_ENV === 'development') {
              console.log('Infaq parsing:', {
                original: this.infaq_payment_amount,
                cleaned: cleaned,
                parsed: infaqAmount
              })
            }
          } else {
            // If it's already a number, ensure it's an integer
            infaqAmount = parseInt(String(this.infaq_payment_amount), 10) || 0
            // Debug log
            if (process.env.NODE_ENV === 'development') {
              console.log('Infaq number:', {
                original: this.infaq_payment_amount,
                parsed: infaqAmount
              })
            }
          }
        }
        if (infaqAmount > 0) {
          kembalian = kembalian - infaqAmount
        }

        // Apply round-up if set (add to kembalian)
        // Only apply if round-up is a valid positive number
        const roundUpAmount = parseInt(this.round_up_return_amount) || 0
        if (roundUpAmount > 0) {
          kembalian = kembalian + roundUpAmount
        }

        // Ensure kembalian is not negative (shouldn't happen, but safety check)
        if (kembalian < 0) {
          kembalian = 0
        }

        // Set money_changes with calculated kembalian
        this.money_changes = kembalian
      }
    },

    calculateInfaq() {
      // Check if any payment method is cash
      const hasCashPayment = this.payment_temp.some(
        item =>
          item.payment_method_id &&
          this.isPaymentMethodCash(item.payment_method_id)
      )

      // If no cash payment, kembalian is always 0
      if (!hasCashPayment) {
        this.money_changes = 0
        this.isError.infaq = false
        return
      }

      let total_bayar = 0

      for (const payment of this.payment_temp) {
        const amount = payment.amount || 0
        total_bayar += isNaN(amount) ? 0 : amount
      }

      let kembalian = total_bayar - this.total_billed_amount

      // Parse infaq amount properly - handle string values and remove formatting
      // Infaq should be an integer (rupiah), so use parseInt, not parseFloat
      let infaqAmount = 0
      if (
        this.infaq_payment_amount != null &&
        this.infaq_payment_amount !== '' &&
        this.infaq_payment_amount !== 0
      ) {
        // Handle string values (remove any formatting like dots for thousands, commas)
        if (typeof this.infaq_payment_amount === 'string') {
          // Remove all non-digit characters, then parse as integer
          const cleaned = String(this.infaq_payment_amount).replace(
            /[^\d]/g,
            ''
          )
          infaqAmount = parseInt(cleaned, 10) || 0
          // Debug log to see what's happening
          if (process.env.NODE_ENV === 'development') {
            console.log('calculateInfaq - Infaq parsing:', {
              original: this.infaq_payment_amount,
              type: typeof this.infaq_payment_amount,
              cleaned: cleaned,
              parsed: infaqAmount
            })
          }
        } else {
          // If it's already a number, ensure it's an integer
          infaqAmount = parseInt(String(this.infaq_payment_amount), 10) || 0
          // Debug log
          if (process.env.NODE_ENV === 'development') {
            console.log('calculateInfaq - Infaq number:', {
              original: this.infaq_payment_amount,
              type: typeof this.infaq_payment_amount,
              parsed: infaqAmount
            })
          }
        }
      }

      if (infaqAmount == null || infaqAmount === 0) {
        this.isError.infaq = false
        this.money_changes = kembalian
      } else if (infaqAmount > kembalian || infaqAmount < 0) {
        this.isError.infaq = true
        this.error_msg.infaq = 'Jumlah infaq melebihi kembalian'
        this.money_changes = kembalian
      } else {
        this.isError.infaq = false
        this.money_changes = kembalian - infaqAmount
      }
    },

    calculateRoundUp() {
      // Check if any payment method is cash
      const hasCashPayment = this.payment_temp.some(
        item =>
          item.payment_method_id &&
          this.isPaymentMethodCash(item.payment_method_id)
      )

      // If no cash payment, kembalian is always 0
      if (!hasCashPayment) {
        this.money_changes = 0
        return
      }

      let total_bayar = 0

      for (const payment of this.payment_temp) {
        const amount = payment.amount || 0
        total_bayar += isNaN(amount) ? 0 : amount
      }

      let kembalian = total_bayar - this.total_billed_amount

      // Apply infaq if set (needed for round-up calculation)
      // Infaq should be an integer (rupiah), so use parseInt, not parseFloat
      let infaqAmount = 0
      if (
        this.infaq_payment_amount != null &&
        this.infaq_payment_amount !== '' &&
        this.infaq_payment_amount !== 0
      ) {
        if (typeof this.infaq_payment_amount === 'string') {
          // Remove all non-digit characters except minus sign, then parse as integer
          const cleaned = String(this.infaq_payment_amount).replace(
            /[^\d-]/g,
            ''
          )
          infaqAmount = parseInt(cleaned, 10) || 0
        } else {
          // If it's already a number, ensure it's an integer
          infaqAmount = parseInt(this.infaq_payment_amount, 10) || 0
        }
      }
      if (infaqAmount > 0) {
        kembalian = kembalian - infaqAmount
      }

      // Parse round-up amount properly
      let roundUpAmount = 0
      if (
        this.round_up_return_amount != null &&
        this.round_up_return_amount !== '' &&
        this.round_up_return_amount !== 0
      ) {
        if (typeof this.round_up_return_amount === 'string') {
          const cleaned = String(this.round_up_return_amount)
            .replace(/\./g, '')
            .replace(/,/g, '')
          roundUpAmount = parseInt(cleaned, 10) || 0
        } else {
          roundUpAmount = parseInt(this.round_up_return_amount, 10) || 0
        }
      }

      if (roundUpAmount == null || roundUpAmount === 0) {
        this.isError.round_up = false
        this.money_changes = kembalian
      } else {
        this.isError.round_up = false
        this.money_changes = kembalian + roundUpAmount
      }
    },

    calculateDiscount() {
      this.total_discount = 0
      this.isError.discount_item = false
      for (const cartItem of this.cart) {
        if (cartItem.discount > MAX_DISCOUNT_PERCENTAGE) {
          this.isError.discount_item = true
          this.error_msg.discount_item = 'Diskon harus dibawah 100%'
        }
        this.total_discount +=
          cartItem.qty * cartItem.price * (cartItem.discount / 100)
      }
    },

    saveTransaction(isPayingMethod) {
      this.loading.transaction = true
      if (this.cart.length === 0) {
        this.loading.transaction = false
        this.$toast.add({
          severity: 'error',
          summary: 'Keranjang tidak boleh kosong',
          life: TOAST_DURATION_MS
        })
        return
      }

      if (!this.customers_selected) {
        this.loading.transaction = false
        this.$toast.add({
          severity: 'error',
          summary: 'Pilih customer',
          life: TOAST_DURATION_MS
        })
        return
      }

      // check if in transaction items.discount > 100 give error
      for (const item of this.cart) {
        if (item.discount > MAX_DISCOUNT_PERCENTAGE) {
          this.loading.transaction = false
          this.$toast.add({
            severity: 'error',
            summary: 'Diskon item harus dibawah 100%',
            life: TOAST_DURATION_MS
          })
          return
        }
      }

      if (!this.salespersons_selected || this.salespersons_selected == null) {
        this.transaction.salesperson_id = null
      } else {
        this.transaction.salesperson_id = this.salespersons_selected.id
      }

      this.transaction.cust_id = this.customers_selected.id
      this.transaction.items = this.cart
      this.transaction.discount = this.discount_transaction_value

      if (this.voucher_code_used != null) {
        this.transaction.voucher_code = this.voucher_code_used
      }

      this.$http
        .post(
          `${process.env.VUE_APP_API_URL}/pos/transactions${
            this.transaction.id === 0 ? '' : '?id=' + this.transaction.id
          }`,
          this.transaction
        )
        .then(response => {
          this.loading.transaction = false
          if (response.status == 200) {
            if (isPayingMethod) {
              this.transaction.id = response.data.data.id
              this.calculateTransaction()
            } else {
              this.calculateTransactionOnly()
              this.clearTransaction()
              setTimeout(() => {
                if (this.$refs.posInput && this.$refs.posInput.$refs.barcode) {
                  this.$refs.posInput.$refs.barcode.$el.focus()
                }
              }, 1000)
              this.$toast.add({
                severity: 'success',
                summary: 'Berhasil menyimpan transaksi',
                life: TOAST_DURATION_MS
              })
            }
          } else {
            this.loading.transaction = false
            this.$toast.add({
              severity: 'error',
              summary: 'Gagal memproses transaksi',
              life: TOAST_DURATION_MS
            })
          }
        })
        .catch(error => {
          this.loading.transaction = false

          // Handle insufficient stock error (400)
          if (
            error.response &&
            error.response.status === 400 &&
            error.response.data &&
            error.response.data.message === 'error.insufficient.stock' &&
            error.response.data.details &&
            error.response.data.details.items &&
            error.response.data.details.items.length > 0
          ) {
            const insufficientItems = error.response.data.details.items
            const itemDetails = []

            // Match error items with cart items to get item names and update stock
            for (const errorItem of insufficientItems) {
              const cartItem = this.cart.find(
                item =>
                  item.code === errorItem.item_code ||
                  item.id === errorItem.item_id
              )

              // Update cart item stock with actual available stock from server
              if (cartItem) {
                this.$set(cartItem, 'stock', errorItem.available)
                itemDetails.push(
                  `${cartItem.name} (${errorItem.item_code}): Diminta ${errorItem.requested}, Tersedia ${errorItem.available}`
                )
              } else {
                itemDetails.push(
                  `${errorItem.item_code}: Diminta ${errorItem.requested}, Tersedia ${errorItem.available}`
                )
              }
            }

            // Build error message
            const itemsList = itemDetails.join('\n')
            const summaryMessage =
              insufficientItems.length === 1
                ? 'Stok tidak mencukupi untuk 1 item'
                : `Stok tidak mencukupi untuk ${insufficientItems.length} item`

            this.$toast.add({
              severity: 'error',
              summary: summaryMessage,
              detail: `${itemsList}\n\nSilakan sesuaikan jumlah barang di keranjang sesuai stok yang tersedia.`,
              life: TOAST_DURATION_MS * 3 // Show longer for detailed message with multiple items
            })
          } else {
            // Handle other errors
            const errorMessage =
              error.response &&
              error.response.data &&
              error.response.data.message
                ? error.response.data.message
                : 'Gagal memproses transaksi'

            this.$toast.add({
              severity: 'error',
              summary: 'Gagal memproses transaksi',
              detail: errorMessage,
              life: TOAST_DURATION_MS
            })
          }
        })
    },

    calculateTransactionOnly() {
      this.$http
        .post(
          `${process.env.VUE_APP_API_URL}/pos/transactions/${this.transaction.id}/calculate`
        )
        .then(resp => {
          console.log(
            'calculated transaction: ',
            this.transaction.id,
            resp.status
          )
        })
    },

    calculateTransaction() {
      this.$http
        .post(
          `${process.env.VUE_APP_API_URL}/pos/transactions/${this.transaction.id}/calculate`
        )
        .then(response => {
          if (response.status == 200) {
            this.payment.invoice_id = response.data.data.invoice.id
            this.total_billed_amount =
              response.data.data.invoice.amount - this.voucher_amount
            this.payment_temp[0].amount = this.total_billed_amount
            // Calculate total bayar to match the initial payment amount
            this.calculateTotalBayar()
            this.money_changes = 0
            this.dialog.payment = true
            this.payment_pay = false
            // non-active error message
            this.nonActiveError()
            // filed jumlah bayar active
            setTimeout(() => {
              if (this.$refs.payment && this.$refs.payment[0]) {
                this.$refs.payment[0].$el.querySelector('.p-inputtext').focus()
              }
            }, 500)
          } else {
            this.$toast.add({
              severity: 'error',
              summary: 'Gagal memproses transaksi',
              life: TOAST_DURATION_MS
            })
          }
        })
    },

    nonActiveError() {
      this.isError.payment_amount = false
      this.error_msg.payment_amount = ''
      this.isError.infaq = false
      this.error_msg.infaq = ''
      this.infaq_payment_amount = 0
      this.round_up_return_amount = 0
      this.total_bayar = 0

      let idx = this.payment_temp.indexOf(this.payment_temp[1])
      if (idx > -1) {
        this.payment_temp.splice(idx, 1)
      }
    },

    handleEnter() {
      if (!this.enterPressed) {
        this.enterPressed = true
        this.payTransaction()
      }
    },

    payTransaction() {
      // Guard: prevent double ENTER / double shortkey from calling endpoint twice.
      // Set loading immediately so a second invocation returns before making another request.
      if (this.loading.payment) {
        return
      }
      this.loading.payment = true

      // Parse infaq amount properly before using
      let infaqAmount = 0
      if (
        this.infaq_payment_amount != null &&
        this.infaq_payment_amount !== ''
      ) {
        if (typeof this.infaq_payment_amount === 'string') {
          const cleaned = String(this.infaq_payment_amount)
            .replace(/\./g, '')
            .replace(/,/g, '')
          infaqAmount = parseInt(cleaned, 10) || 0
        } else {
          infaqAmount = parseInt(this.infaq_payment_amount, 10) || 0
        }
      }
      this.payment.infaq = infaqAmount
      this.payment.round_up = parseInt(this.round_up_return_amount)
      this.payment.change = parseInt(this.money_changes)
      this.payment.payment = this.payment_temp.map(item => {
        return {
          payment_method_id: item.payment_method_id.id,
          amount: item.amount
        }
      })
      this.payment.voucher_code = this.voucher_code

      let total_bayar = 0
      for (const payment of this.payment_temp) {
        total_bayar += payment.amount
      }

      if (total_bayar < this.total_billed_amount) {
        this.loading.payment = false
        this.$toast.add({
          severity: 'error',
          summary: `Pembayaran tidak cukup`,
          life: TOAST_DURATION_MS
        })
        return
      }

      if (this.isError.infaq) {
        this.loading.payment = false
        this.$toast.add({
          severity: 'error',
          summary: 'Jumlah infaq melebihi jumlah uang yang dibayarkan',
          life: TOAST_DURATION_MS
        })
        return
      }

      this.money_changes =
        parseInt(total_bayar) -
        parseInt(this.total_billed_amount) -
        parseInt(this.infaq_payment_amount) +
        parseInt(this.round_up_return_amount)

      this.$http
        .post(`${process.env.VUE_APP_API_URL}/pos/payments`, this.payment)
        .then(response => {
          if (response.status == 200) {
            this.enterPressed = false
            this.loading.payment = false
            this.dialog.payment = false
            this.dialog.change = true
            //print receipt - use dialog instead of new tab
            this.receiptInvoiceId = this.payment.invoice_id
            this.dialog.receiptPreview = true
            this.getTemporaryOmset()
            this.clearTransaction()
          } else if (response.data.message == 'error.payment.no_change') {
            this.loading.payment = false
            this.$toast.add({
              severity: 'error',
              summary: 'Tidak boleh ada kembalian',
              life: TOAST_DURATION_MS
            })
          } else {
            this.loading.payment = false
            this.$toast.add({
              severity: 'error',
              summary: 'Gagal memproses transaksi',
              life: TOAST_DURATION_MS
            })
          }
        })
        .catch(error => {
          this.loading.payment = false
          console.error('Payment request failed:', error)
          this.$toast.add({
            severity: 'error',
            summary: 'Gagal memproses transaksi',
            detail:
              (error.response &&
                error.response.data &&
                error.response.data.message) ||
              error.message ||
              'Terjadi kesalahan jaringan',
            life: TOAST_DURATION_MS
          })
        })
    },

    addPaymentMethod() {
      // Calculate remaining amount needed
      const remainingAmount = this.getRemainingAmount()
      this.payment_temp.push({
        payment_method_id: null,
        amount: remainingAmount
      })
      this.calculateChange()
    },

    removePaymentMethod(an_item) {
      let idx = this.payment_temp.indexOf(an_item)
      if (idx > -1) {
        this.payment_temp.splice(idx, 1)
      }
      this.calculateChange()
    },

    clearTransaction() {
      this.salespersons_selected = null
      this.customers_selected = null
      this.create_customer = {
        name: '',
        phone: '',
        email: '',
        type: 'REGULAR'
      }

      this.cart = []
      this.snapshot = []
      this.lengthCart = 0

      this.qty_total = 0
      this.sub_total = 0
      this.total_discount = 0
      this.billed_amount = 0
      this.total_billed_amount = 0
      this.infaq_payment_amount = 0
      this.round_up_return_amount = 0

      this.discount_type = null
      this.discount_transaction_percentage = null
      this.discount_transaction_value = 0

      this.getPaymentMethods()
      this.getCustomers('', this.outlet.phone)

      this.transaction = {
        id: '',
        salesperson_id: null,
        cust_id: null,
        items: [],
        discount: null
      }

      this.total_bayar = 0
      this.payment_temp = [
        {
          payment_method_id: null,
          amount: 0
        }
      ]
      this.payment = {
        invoice_id: 0,
        payment: [],
        infaq: 0,
        voucher_code: ''
      }

      this.payment_amount = 0
      this.bank_account = null

      this.clearVoucher()
    },

    openHistoryList(value) {
      this.dialog.history = value !== undefined ? value : true
      this.getListHistory()
    },

    getListHistory() {
      this.$http
        .get(`${process.env.VUE_APP_API_URL}/pos/invoices?status=1`)
        .then(response => {
          if (response.status === 200) {
            let struk_histories = [...response.data.data.invoices]
            const duplikatStruk = [
              ...new Map(struk_histories.map(item => [item.id, item])).values()
            ]
            this.transaction_histories = duplikatStruk
          }
        })
    },

    confirmOpenShift() {
      this.opening_balance = Number(this.user.shift.opening_balance)
      this.dialog.open_shift = true
    },

    openShift() {
      const shiftData = {
        opening_balance: this.opening_balance
      }

      this.$http
        .post(`${process.env.VUE_APP_API_URL}/shifts/open`, shiftData)
        .then(response => {
          if (response.status === 200) {
            this.$toast.add({
              severity: 'success',
              summary: 'Berhasil memulai shift',
              life: TOAST_DURATION_MS
            })

            this.dialog.open_shift = false
            this.$store
              .dispatch('setUser', { requestOptions: { method: 'GET' } })
              .then(() => {
                this.getAuthUser()
              })
            this.customer_isExist_dialog
          } else {
            this.$toast.add({
              severity: 'error',
              summary: 'Gagal memulai shift',
              life: TOAST_DURATION_MS
            })
          }
        })
        .catch(error => {
          console.error('Error opening shift:', error)
          this.$toast.add({
            severity: 'error',
            summary: 'Gagal memulai shift',
            detail:
              (error.response &&
                error.response.data &&
                error.response.data.message) ||
              'Terjadi kesalahan',
            life: TOAST_DURATION_MS
          })
        })
    },

    logout() {
      this.$store
        .dispatch('logout', { requestOptions: { method: 'POST' } })
        .then(() => {
          setTimeout(() => {
            this.$router.push({ name: 'login' })
            this.$router.go()
          }, 1000)
        })
    },

    checkAuditDateWarning() {
      // Only show once per session
      if (sessionStorage.getItem('auditWarningDismissed')) return
      if (this.user && this.user.shift && this.user.shift.audit_date) {
        const auditDate = new Date(this.user.shift.audit_date)
        const now = new Date()
        const diffMs = now - auditDate
        const diffHours = diffMs / (1000 * 60 * 60)
        if (diffHours > AUDIT_DATE_THRESHOLD_HOURS) {
          this.dialog.audit_date = true
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
/* ===== POS LAYOUT SYSTEM ===== */
.pos-layout {
  display: grid;
  grid-template-columns: 1fr 200px;
  grid-template-rows: auto 1fr;
  column-gap: 1rem;
  row-gap: 0.5rem;
  height: 100vh;
  padding: 0.5rem;
  background-color: #f8fafc;

  @media (max-width: 1200px) {
    grid-template-columns: 1fr 180px;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    grid-template-rows: auto auto 1fr;
    column-gap: 0.5rem;
    row-gap: 0.5rem;
    padding: 0.25rem;
  }
}

/* Header Zone */
.pos-header-zone {
  grid-column: 1 / -1;
  grid-row: 1;
  background: #ffffff;
  border-radius: 0.5rem;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  padding: 0.75rem;
}

/* Main Zone */
.pos-main-zone {
  grid-column: 1;
  grid-row: 2;
  background: #ffffff;
  border-radius: 0.5rem;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.pos-main-content {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0; /* Important for flex child */
}

.pos-input-section {
  padding: 0.75rem;
  border-bottom: 1px solid #e2e8f0;
  background: #f8fafc;
  flex-shrink: 0;
}

.pos-cart-section {
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  min-height: 0; /* Important for flex child */
}

/* Controls Zone */
.pos-controls-zone {
  grid-column: 2;
  grid-row: 2;
  background: #ffffff;
  border-radius: 0.5rem;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  padding: 0.75rem;
  overflow-y: auto;

  @media (max-width: 768px) {
    grid-column: 1;
    grid-row: 3;
  }
}

/* ===== LEGACY STYLES ===== */
.required-label {
  color: red;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.add-customer:hover {
  cursor: pointer;
}

.container {
  width: 100%;
  margin: 0px;
  padding: 0px;
}

.card-qty {
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.2);
  margin-bottom: 1rem;
  padding: 1.05rem;
}

.card-qty-title {
  font-size: 18px;
  font-weight: 700;
}

.item {
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 170px;
}

.section {
  background-color: #ffffff;
  padding: 10px;
  margin: 0px;
  border: 1px solid #ddd;
}

.snapshot-code {
  font-weight: 700;
  font-size: 18px;
  word-wrap: break-word;
  text-align: center;
  padding: 5px 10px 0px 10px;
  margin-bottom: 5px;
}

.code-kosong {
  padding: 70px 0px;
}

.snapshot-card {
  height: 100%;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
  margin-bottom: 1rem;
}

.snapshot-name-price {
  font-size: 12px;
  font-weight: 500;
  word-wrap: break-word;
  text-align: center;
  margin: 5px 10px 0px 10px;
}

.snapshot-img {
  max-width: 100% !important;
  padding: 0px;
  height: 16vh;
  display: block;
  margin: auto;
}

/* Legacy table styles - keeping for compatibility */
.table-items:hover {
  background-color: rgba($color: #04bfe4, $alpha: 0.1);
}

.product-code {
  font-size: 11px;
  margin: 0px;
  font-weight: bold;
}
.product-name {
  font-size: 1.3rem;
  font-weight: 700;
}

.product-initPrice {
  font-size: 1.1rem;
  color: #eb1d36;
  text-decoration: line-through;
  font-style: italic;
}

.product-code-discount {
  background-color: #ffdddd;
  text-align: center;
  padding: 0.2rem;
  font-size: 11px;
  font-weight: 700;
  border-radius: 0.2rem;
  color: #eb1d36;
}

.product-price {
  font-size: 15px;
}

.product-description {
  margin: 0.4rem 0rem;
  text-align: center;
}

.product-badge {
  border-radius: 1px;
  padding: 0.25em 0.25rem;
  text-transform: uppercase;
  font-weight: bold;
  font-size: 12px;
  letter-spacing: 0.3px;

  &.status-instock {
    background: #c8e6c9;
    color: #256029;
  }

  &.status-outofstock {
    background: #ffcdd2;
    color: #c63737;
  }

  &.discount {
    background: #ffcdd2;
    color: #c63737;
  }

  &.status-lowstock {
    background: #feedaf;
    color: #8a5340;
  }
}

/deep/ .product-grid-item {
  margin: 0.5em;
  border: 0.5px solid #dee2e6;
  padding: 10px 8px !important;

  .product-grid-item-top,
  .product-grid-item-bottom {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  img {
    width: 75%;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
    margin: 2rem 0;
  }

  .product-grid-item-content {
    text-align: center;
  }

  .product-price {
    font-size: 1.3rem;
    text-align: center;
  }

  .product-stok {
    font-size: 1rem;
    text-align: center;
  }
}

@media screen and (max-width: 576px) {
  .product-list-item {
    flex-direction: column;
    align-items: center;

    img {
      width: 75%;
      margin: 2rem 0;
    }

    .product-list-detail {
      text-align: center;
    }

    .product-price {
      align-self: center;
    }

    .product-list-action {
      display: flex;
      margin-top: 2rem;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      width: 100%;
    }
  }
}
// Receipt Loading Overlay Styles
.receipt-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  backdrop-filter: blur(2px);
}

.receipt-loading-content {
  background-color: white;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: 200px;

  p {
    margin-top: 1rem;
    color: #495057;
    font-size: 1rem;
    font-weight: 500;
  }
}
</style>
